import React from 'react';
import HvSvg from 'src/components/HvSvg';

import {
  BigTrashcanIconContainer,
  DeleteSplitContainer,
  DeleteSplitHeader,
  SplitRemovedMessageText,
  TrashcanIconAndHeader,
  TrashcanIconAndHeaderContainer,
} from './styled';

const DeleteSplit = () => (
  <DeleteSplitContainer>
    <TrashcanIconAndHeaderContainer>
      <TrashcanIconAndHeader>
        <BigTrashcanIconContainer size={103}>
          <HvSvg src={require('src/assets/icons/trashcan.svg')} />
        </BigTrashcanIconContainer>
        <DeleteSplitHeader>Delete Split</DeleteSplitHeader>
      </TrashcanIconAndHeader>
    </TrashcanIconAndHeaderContainer>
    <SplitRemovedMessageText>
      Are you sure?
      <br />
      <br />
      Cancel will restore the split, or click Confirm if you're sure you want to
      remove it.
    </SplitRemovedMessageText>
  </DeleteSplitContainer>
);

export default DeleteSplit;
